<template>
    <div>
        <div class="container-wide login-box">
            <div class="login-title">{{getLabel('LOGIN_FORGET_PWD')}}</div>
            <p class="login-tip">{{getLabel('FORGET_GUIDE')}}</p>
            <a-form
                v-if="!hasSend"
                @submit="handleSubmit"
                :form="form"
                class='login-form'>
                <a-form-item>
                    <a-input
                        v-decorator="['mail', {rules: [{ type: 'email', message: this.getLabel('TIP_EMAIL_WRONG') }, { required: true, message: this.getLabel('TIP_EMAIL_REQUIRED') }]}]"
                        :placeholder="getLabel('LOGIN_INPUT_NAME_PLACEHOLDER')"
                        size="large"
                        autocomplete="off"
                    >
                    </a-input>
                </a-form-item>
                <a-form-item style="padding-top:40px;">
                    <a-button type='primary' htmlType='submit' class='login-form-button' size="large" block>
                        {{getLabel('NEXT')}}
                    </a-button>
                </a-form-item>
            </a-form>
            <div v-if="hasSend" class="login-result">
                <p class="login-result-title"><i class="login-icon-email"></i>{{getLabel('FORGET_GUIDE2')}}</p>
                <p class="login-result-tip">{{getLabel('FORGET_GUIDE3')}}：<span class="word-blue">{{currentMail}}</span> {{getLabel('FORGET_GUIDE4')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Language from '../util/language';

    export default {
	    data () {
		    return {
			    form: this.$form.createForm(this)
		    }
	    },
	    computed: {
		    ...mapState({
			    language: state => state.main.language,
                hasSend: state => state.forget.hasSend,
			    currentMail: state => state.forget.currentMail
		    })
	    },
	    methods: {
		    handleSubmit: function (e) {
			    e.preventDefault();
			    this.form.validateFields((err, values) => {
				    if (!err) {
					    this.$store.dispatch('forget/sendMail', values);
				    }
			    })
		    },
		    // 获取描述
		    getLabel: function (key) {
			    return Language(this.language, key);
		    }
	    }
    }
</script>

<style lang="less" scoped>
    @import "../assets/less/login";
</style>